import { apiClient, type ApiClientResponse, routes } from 'common/services';

export const unSync = async () => apiClient.delete<undefined, ApiClientResponse<undefined>>(routes.dexcom.unSync);
